module.exports = __webpack_public_path__ + "assets/img/jtfx61.3425a351.jpg";